module.exports = __webpack_public_path__ + "static/img/login_zs_bg.98124f57.png";